// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tauros_paldea_blaze_breed: PokeData = {
  "id": 10251,
  "name": "tauros-paldea-blaze-breed",
  "height": 14,
  "weight": 850,
  "base_experience": 172,
  "types": [
    PokeType.FIGHTING,
    PokeType.FIRE
  ],
  "api_moves": [
    "double-kick",
    "headbutt",
    "tackle",
    "thrash",
    "tail-whip",
    "rest",
    "scary-face",
    "swagger",
    "close-combat",
    "flare-blitz",
    "zen-headbutt",
    "flame-charge",
    "work-up",
    "raging-bull"
  ],
  "moves": [
    "double-kick",
    "headbutt",
    "tackle",
    "scary-face",
    "close-combat",
    "flare-blitz",
    "zen-headbutt",
    "meteor-assault",
    "fire-spin",
    "flamethrower",
    "fire-ball",
    "fire-punch",
    "blaze-kick"
  ],
  "evolution_chain": {
    "id": 63,
    "item": null,
    "species": [
      {
        "name": "tauros",
        "order": 152,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 112,
    "speed": 137,
    "ability_power": 151
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "paldea"
} as const;
